// src/api/firebase.ts
// ForgeOS — Firebase Backend
// ForgeByte Technologies LLC

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD8evwbk5MwNQjzd3OjEwuPXDn0VCvxP70",
  authDomain: "forgeos-1507f.firebaseapp.com",
  projectId: "forgeos-1507f",
  storageBucket: "forgeos-1507f.firebasestorage.app",
  messagingSenderId: "589889857022",
  appId: "1:589889857022:web:5510ef17467c8b9bb04caf",
  measurementId: "G-32DXZN0CDD"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
